
<div class="all_outer">
    <mat-card class="filter">
      <button mat-button [matMenuTriggerFor]="menu"><mat-icon>view_kanban</mat-icon> Kanban<mat-icon>keyboard_arrow_down</mat-icon></button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="CCCKanban()"><mat-icon>view_kanban</mat-icon> Kanban View</button>
        <button mat-menu-item (click)="CCCListing()"><mat-icon>list</mat-icon> List View</button>
        <button mat-menu-item (click)="CCCGridView()"><mat-icon>group_work</mat-icon> Grouping view</button>
      </mat-menu>

    <button *ngIf="showColumn==true" class="viewBtn" (click)="customizeColumn(customize)" mat-icon-button matTooltipClass="tooltip"
      matTooltip="Customize Coloumn">
    <mat-icon>view_column</mat-icon>
    </button>

    </mat-card>

    

    <div class="outer_col">
      
        <div class="col_holder" *ngFor="let ccc of CCCList; let i = index">
            <div *ngIf="colorShow==false" (click)="showColor(ccc)" class="statusName" [ngStyle]="{'box-shadow': '0 3px 0' + ccc.color + ' inset','color': ccc.color,'cursor':'pointer'}">
                {{ccc.id}} <span>({{ccc.datalist.length}})</span>
                <!-- <div class="colorOptions" *ngIf="colorShow==true && ccc.id==columnname">
                  <ng-container *ngFor="let col of colors">
                    <span [ngStyle]="{'background-color': col.color}" ></span>
                  </ng-container>                  
                </div> -->
            </div>

            <div *ngIf="colorShow==true" (click)="closeColor(ccc)" class="statusName" [ngStyle]="{'box-shadow': '0 3px 0' + ccc.color + ' inset','color': ccc.color,'cursor':'pointer'}">
              {{ccc.id}} <span>({{ccc.datalist.length}})</span>
              <div class="colorOptions" *ngIf="colorShow==true && ccc.id==columnname">
                <ng-container *ngFor="let col of colors">
                  <span (click)="selectedColor(ccc,col)" [ngStyle]="{'background-color': col.color}" ></span>
                </ng-container>                  
              </div>
           </div>

            <div class="col" cdkDropList id="{{ccc.id}}" [cdkDropListData]="ccc.datalist"
              [cdkDropListConnectedTo]="connectedTo" (cdkDropListDropped)="drop($event)">

                <div class="cardUI" *ngFor="let cccItem of ccc.datalist" cdkDrag>
                  <div class="title" (click)="openDetails(cccItem)">
                    {{cccItem.title}}  
                  </div>
                   <div class="dueDate">
                    Created on <span>
                      {{cccItem.createdOn+'Z' | date:'MM/dd/yyyy'}}                      
                    </span>
                   </div> 
                </div>
                
            </div>
        </div>

      
    </div>
</div>


<ng-template #customize>
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>view_column</mat-icon>
      </span>
      Select the columns you want to display in this list
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
  
  
    <mat-dialog-content class="mat-typography">
  
      <div class="allheaders">
        <div class="fixrow sep">
          <span> </span>
          <span>Column Headers</span>
          <span> Active Columns</span>
        </div>
  
        <ng-container *ngFor="let item of FieldColumnToogle;let i = index">        
          <div class="sep">
            <div  class="Colrd" [ngStyle]="{'background-color': item.color }"></div>
            <span>{{item.status}}</span>
            
            
            <span>
              <mat-slide-toggle [checked]="item.isChecked" color="primary" (change)="changedToggle(item,$event)">
              </mat-slide-toggle>
            </span>
          </div>
        </ng-container>
      </div>
  
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
    </mat-dialog-actions>
  </ng-template>

  <app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='TransactionId' [modulenames]='Module' 
  (closeDetail)="getCloseDetails($event)">
  </app-details>
  
  <app-loader></app-loader>